export { _logger as Logger };

const _logger = function (params) {
  this._prefix = params.modulePrefix;
  this._file = "(" + params.file + ")";

  this._levels = {
    log: "log",
    info: "info",
    debug: "debug",
    error: "error",
  };

  this._baseMethod = (level, logArgs) => {
    let args = this._getFormatArguments({ level, logArgs });
    return console[level].apply(null, args);
  };

  this._getFormatArguments = (params) => {
    let args = Array.prototype.slice.call(params.logArgs) || [];
    args.unshift(this._prefix);
    args.unshift("[" + params.level.toUpperCase() + "]");
    args.push(this._file);
    return args;
  };

  this[this._levels.log] = function () {
    return this._baseMethod(this._levels.log, arguments);
  };
  this[this._levels.info] = function () {
    return this._baseMethod(this._levels.info, arguments);
  };
  this[this._levels.debug] = function () {
    return this._baseMethod(this._levels.debug, arguments);
  };
  this[this._levels.error] = function () {
    return this._baseMethod(this._levels.error, arguments);
  };
};
